export const Padding = {
    medium: "24px",
    large: "32px",
    small: "18px"
};
